var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "289F61F9-F9DE-4CC2-9F9F-F5E2B2B5C6C2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Company-Portal",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard1",
    transform: "translate(-18.000000, -889.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    x: 0,
    y: 0,
    width: 1680,
    height: 1015
  }), /*#__PURE__*/React.createElement("g", {
    id: "Nav-CompanyAdmin"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "none",
    x: 0,
    y: 0,
    width: 245,
    height: 1015
  }), /*#__PURE__*/React.createElement("g", {
    id: "Nav-Off",
    transform: "translate(0.000000, 877.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "NavLogout",
    transform: "translate(18.000000, 889.000000)",
    fill: "#89888D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: 1214656,
    transform: "translate(4.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.8817842e-16,10 C8.8817842e-16,10.5522847 0.44771525,11 1,11 L8.59,11 L6.29,13.29 C6.10068735,13.4777666 5.99420168,13.7333625 5.99420168,14 C5.99420168,14.2666375 6.10068735,14.5222334 6.29,14.71 C6.4777666,14.8993127 6.73336246,15.0057983 7,15.0057983 C7.26663754,15.0057983 7.5222334,14.8993127 7.71,14.71 L11.71,10.71 C11.8010406,10.6148963 11.8724056,10.5027513 11.92,10.38 C12.020018,10.1365386 12.020018,9.86346136 11.92,9.62 C11.8724056,9.49724868 11.8010406,9.38510371 11.71,9.29 L7.71,5.29 C7.45634143,5.03634142 7.08662601,4.93727646 6.74012195,5.03012194 C6.3936179,5.12296742 6.12296742,5.3936179 6.03012194,5.74012195 C5.93727646,6.08662601 6.03634142,6.45634143 6.29,6.71 L8.59,9 L1,9 C0.44771525,9 8.8817842e-16,9.44771525 8.8817842e-16,10 Z M13,0 L3,0 C1.34314575,0 0,1.34314575 0,3 L0,6 C0,6.55228475 0.44771525,7 1,7 C1.55228475,7 2,6.55228475 2,6 L2,3 C2,2.44771525 2.44771525,2 3,2 L13,2 C13.5522847,2 14,2.44771525 14,3 L14,17 C14,17.5522847 13.5522847,18 13,18 L3,18 C2.44771525,18 2,17.5522847 2,17 L2,14 C2,13.4477153 1.55228475,13 1,13 C0.44771525,13 0,13.4477153 0,14 L0,17 C0,18.6568542 1.34314575,20 3,20 L13,20 C14.6568542,20 16,18.6568542 16,17 L16,3 C16,1.34314575 14.6568542,0 13,0 L13,0 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavLogout);
export default __webpack_public_path__ + "static/media/NavLogout.3114a09ac016005c2bd63bdfbc20e142.svg";
export { ForwardRef as ReactComponent };